import { View } from '../../base/View';
import { ensureElement } from '../../../utils/utils';
import { SETTINGS, AppStateComponents } from '../../../utils/constants';
export class ModalView extends View {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._closeButton = ensureElement(SETTINGS.modalSettings.close, container);
        this._content = ensureElement(SETTINGS.modalSettings.content, container);
        this._closeButton.addEventListener('click', this.close.bind(this));
        this.container.addEventListener('click', this.close.bind(this));
        this._content.addEventListener('click', (event) => event.stopPropagation());
    }
    set content(value) {
        this._content.replaceChildren(value);
    }
    open() {
        this.container.classList.add(SETTINGS.modalSettings.activeClass);
        this.events.emit(AppStateComponents.MODAL.OPEN);
    }
    close() {
        this.container.classList.remove(SETTINGS.modalSettings.activeClass);
        this.content = null;
        this.events.emit(AppStateComponents.MODAL.CLOSE);
    }
    render(data) {
        super.render(data);
        this.open();
        return this.container;
    }
}
